import { DetailSection, LabelText } from '../../../../../../../components/generic';
import { getCurrentUser } from '../../../../../../../services/helper';
import { Course } from '../../../../../../../types/course.type';
import SafeHTMLDisplay from '../../../../../../common/SafeHTMLDisplay';

const currentUser = getCurrentUser();

interface Props {
  course: Course | undefined;
}

export const SessionNotesSection = ({ course }: Props) => {
  if (!currentUser?.isAdmin) return null;

  return (
    <DetailSection title="Notes">
      {course?.venue &&
        (course.venue.organizations.length ?? 0) > 0 &&
        course.venue.organizations.map((org, idx) => (
          <LabelText
            key={idx}
            label={`${org.name} Notes`}
            direction="vertical"
          >
            <SafeHTMLDisplay htmlContent={org.notes || '<em>No notes to show</em>'} />
          </LabelText>
        ))}
      <LabelText
          label="Venue Notes"
          direction="vertical"
      >
        {!currentUser.isInstructor ? (
          <SafeHTMLDisplay htmlContent={course?.venue?.notes || '<em>No notes to show</em>'} />
        ) : (
          <em>No notes to show.</em>
        )}
      </LabelText>
      <LabelText
          label="Facility Use Fee Payment Details"
          direction="vertical"
      >
        {!currentUser.isInstructor ? (
          <SafeHTMLDisplay
            htmlContent={
              course?.venue?.facility_use_fee_payment_details || '<em>No notes to show</em>'
            }
          />
        ) : (
          <em>No notes to show.</em>
        )}
      </LabelText>
      <LabelText
          label="Admin Session Notes"
          direction="vertical"
      >
        <SafeHTMLDisplay htmlContent={course?.admin_notes || '<em>No notes to show</em>'} />
      </LabelText>
    </DetailSection>
  );
};
